import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { login as apiLogin } from './AuthService';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();
  const location = useLocation();
  const forcedMethod = location.state?.forceMethod;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await apiLogin(email, password, forcedMethod);
    
      if (response.requires2FA) {
        localStorage.setItem('velaTempToken', response.tempToken);
        localStorage.setItem('velaPreferredMethod', response.preferredMethod || 'email');
        navigate('/2fa');
      } else if (response.token) {
        localStorage.setItem('velaToken', response.token);
        login(response.token);
        
        if (!response.userRole) {
          setError('Unable to determine user role. Please try again or contact support.');
          return;
        }
        
        if (response.userRole === 'client') {
          navigate('/client');
        } else if (response.userRole === 'midwife') {
          navigate('/midwife');
        } else {
          setError('Invalid user role. Please contact support.');
        }
      } else {
        setError(response.message || 'Login failed');
      }
    } catch (error) {
      setError('An error occurred during login. Please try again.');
    }
  };
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4 py-6">
      <div className="w-full max-w-sm bg-white p-6 rounded-xl shadow-md">
        <img src="/vela-logo.png" alt="Vela Logo" className="h-48 mx-auto mb-4" />
        <h2 className="text-2xl font-semibold text-center text-gray-700 mb-4">Login</h2>

        <form onSubmit={handleLogin} className="space-y-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400" />
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <button type="submit" className="w-full py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-semibold transition">Login</button>
        </form>
      </div>
    </div>
  );
}
